import { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Collapse,
  IconButton,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled, useTheme } from '@mui/material/styles';

const ExpandToggle = styled(IconButton)(({ theme }) => ({
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: ({ expand }) => !expand,
      style: { transform: 'rotate(0deg)' },
    },
    {
      props: ({ expand }) => !!expand,
      style: { transform: 'rotate(180deg)' },
    },
  ],
}));

export function CollapsiblePanelCard({
  title,
  defaultExpanded = true,
  children,
  sx,
  headerAction,
  contentSx,
  expandAriaLabel,
}) {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const theme = useTheme();

  const titleColor = theme.palette.mode === 'light'
    ? theme.palette.newColors.gray
    : theme.palette.newColors.lightGray;

  const toggleExpanded = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <Card sx={{ mb: 2, ...sx }}>
      <CardHeader
        onClick={toggleExpanded}
        sx={{ cursor: 'pointer', py: 1.5, px: 2 }}
        title={title}
        titleTypographyProps={{
          fontSize: 18,
          fontWeight: 700,
          color: titleColor,
        }}
        action={(
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {headerAction}
            <ExpandToggle
              expand={expanded}
              aria-expanded={expanded}
              aria-label={expandAriaLabel}
              size="small"
              onClick={(event) => {
                event.stopPropagation();
                toggleExpanded();
              }}
            >
              <ExpandMoreIcon sx={{ color: titleColor }} />
            </ExpandToggle>
          </Box>
        )}
      />
      <Collapse in={expanded} timeout="auto" unmountOnExit={false}>
        <CardContent
          sx={{
            pt: 0,
            px: 0,
            pb: 0,
            '&:last-child': { pb: 0 },
            ...contentSx,
          }}
        >
          {children}
        </CardContent>
      </Collapse>
    </Card>
  );
}
